import { useEffect } from 'react'

import { useRecoilCallback, useRecoilState, useResetRecoilState } from 'recoil'

import { messageDetailsState } from './state'
import { fetchDetailsCallback } from './callbacks'
import PropTypes from 'prop-types'

const useMessageDetails = (idMessage) => {
  const intIdMessage = parseInt(idMessage)
  const [details, setDetails] = useRecoilState(messageDetailsState(intIdMessage))
  const reset = useResetRecoilState(messageDetailsState(intIdMessage))
  const fetchDetails = useRecoilCallback(fetchDetailsCallback, [])

  useEffect(() => {
    if (idMessage) {
      fetchDetails(intIdMessage)
    }
  }, [intIdMessage])

  useEffect(() => {
    return () => {
      reset()
    }
  }, [])

  return [details, setDetails]
}

export default useMessageDetails

useMessageDetails.propTypes = {
  idMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}
